module.exports = __webpack_public_path__ + "static/media/139.c4b84331.jpg";